import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatasetCard = _resolveComponent("DatasetCard")
  const _component_LayersCard = _resolveComponent("LayersCard")
  const _component_LayerFilters = _resolveComponent("LayerFilters")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.$route.path.includes('new'))
      ? (_openBlock(), _createBlock(_component_DatasetCard, {
          key: 0,
          documentDataProp: _ctx.documentDataProp,
          isDatasetChosen: _ctx.isDatasetChosen,
          onDatasetChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('datasetChanged', $event))),
          onDatasetDeleted: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('datasetDeleted')))
        }, null, 8, ["documentDataProp", "isDatasetChosen"]))
      : _createCommentVNode("", true),
    _createVNode(_component_LayersCard, {
      documentDataProp: _ctx.documentDataProp,
      isDatasetChosen: _ctx.isDatasetChosen,
      onLayerChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('layerChanged', $event)))
    }, null, 8, ["documentDataProp", "isDatasetChosen"]),
    (_ctx.documentDataProp.allDrivers && _ctx.documentDataProp.allDrivers.length > 0 && !_ctx.isDatasetChosen)
      ? (_openBlock(), _createBlock(_component_LayerFilters, {
          key: 1,
          documentDataProp: _ctx.documentDataProp,
          onDriverChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('driverChanged', $event)))
        }, null, 8, ["documentDataProp"]))
      : _createCommentVNode("", true)
  ], 64))
}